<template>
    <div
        class="l-ss-c-results-empty-section"
        :class="{ 'l-ss-c-results-empty-section-with-offers': popularOffers.length }">
        <section-results-info
            ref="sectionResultsInfo"
            :search="search"
            :show-autocomplete-elements="false"
            @autocomplete-search="$emit('autocomplete-search', $event)"/>
        <ul
            class="l-ss-c-results-empty-section-tags"
            v-if="popularQueries.length">
            <li
                v-for="(tag, index) in popularQueries"
                :key="`popular-query-tag-${index}`"
                class="l-ss-c-results-empty-section-tag"
                @click="$emit('handle-tags-click', tag.text.value)">
                {{ tag.text.value }}
            </li>
        </ul>

        <div
            class="l-ss-c-results-empty-offers-wrapper"
            :class="{ 'l-ss-c-results-empty-offers-wrapper-mobile': $screen.isMobile }"
            v-if="popularOffers.length">
            <div class="l-ss-c-results-empty-offers-title">{{ $t('results.popularOffers') }}</div>
            <offers-wrapper
                :view="$screen.isMobile ? 'row' : 'grid'"
                :offer-layout="!$screen.isMobile ? 'rowMini' : 'row'"
                :breakpoint="{ columnCount: 2, gridGap: 16, gridGapRow: 8 }"
                :offers="popularOffers"
                @add-to-cart-click="params => $emit('add-to-cart-click', params)"
                @remove-from-cart-click="params => $emit('remove-from-cart-click', params)"
                @add-to-favourites-click="params => $emit('add-to-favourites-click', params)"
                @remove-from-favourites-click="params => $emit('remove-from-favourites-click', params)"/>
        </div>
    </div>
</template>

<script>
    import SectionResultsInfo from '@/core/components/section-results/section-results-info.vue';
    import OffersWrapper from '@/core/components/offers-wrapper.vue';

    export default {
        components: { OffersWrapper, SectionResultsInfo },
        props: {
            search: {
                type: Object,
            },
            configuration: {
                type: Object,
            },
            popularOffers: {
                type: Array,
            },
        },
        data() {
            return {
                localPopularQueries: [],
            };
        },
        computed: {
            popularQueries() {
                return this.localPopularQueries;
            },
        },
        mounted() {
            this.initPopularQueries();
        },
        methods: {
            async initPopularQueries() {
                if (window['searchbooster']) {
                    const controller = window['searchbooster'].api?.controller;
                    setTimeout(async () => {
                        if (controller?.popularQueriesPromise) {
                            const queries = await controller.popularQueriesPromise;
                            this.localPopularQueries = queries || [];
                        }
                    });
                }
            },
        },
    };
</script>
